export default "__VITE_ASSET__DqpvTv7B__"